module.exports = [{
      plugin: require('/tmp/3de8b634/node_modules/gatsby-plugin-google-analytics/gatsby-browser.js'),
      options: {"plugins":[],"trackingId":"UA-39888116-1","respectDNT":true},
    }]
